import type { AuthStateLite, AuthStatePublic } from './types';

/**
 * The initial auth state.
 */
export const initialAuthStatePublic: AuthStatePublic = {
  version: '',
  build_number: '',
  isAuthenticated: false,
  isLoading: false,
  access_token: '',
  id_token: '',
  refresh_token: '',
  score: '',
  userInfo: '',
};

export const initialAuthStateLite: AuthStateLite = {
  version: '',
  build_number: '',
  status: 'init',
  isAuthenticated: false,
  isLoading: false,
  token: '',
  refresh_token: '',
  otpCooldownCount: 0,
  score: '',
  userInfo: '',
  ksid: '',
};